import { render, staticRenderFns } from "./SamplePsiExpression.vue?vue&type=template&id=107a0dd0&scoped=true&"
import script from "./SamplePsiExpression.vue?vue&type=script&lang=js&"
export * from "./SamplePsiExpression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a0dd0",
  null
  
)

export default component.exports